import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../components/Button'
import styles from './Login.module.css'
import { sendResetCode, verifyResetCode } from '../api/security'

export default function ResetCode() {
  const navigate = useNavigate()

  const [email,        setEmail]        = useState('')
  const [code,         setCode]         = useState('')
  const [codeSent,     setCodeSent]     = useState(false)
  const [sending,      setSending]      = useState(false)
  const [verifying,    setVerifying]    = useState(false)
  const [error,        setError]        = useState('')

  async function handleSendCode(e) {
    e.preventDefault()
    setError('')
    setSending(true)
    try {
      await sendResetCode(email)
      setCodeSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setSending(false)
    }
  }

  async function handleVerifyCode(e) {
    e.preventDefault()
    setError('')
    setVerifying(true)
    try {
      await verifyResetCode(code)
      navigate(`/resetpw/${encodeURIComponent(code)}`)
    } catch (err) {
      setError(err.message)
    } finally {
      setVerifying(false)
    }
  }

  return (
    <div className={styles.pageBackground}>
      <div className={styles.card}>

        {/* Logo */}
        <div className={styles.logoRow}>
          <img src="/GaussIQlogo.png" alt="GaussIQ Logo" className={styles.logoImage} />
          <div className={styles.logoText}>
            <span className={styles.logoName}>GaussIQ</span>
            <span className={styles.logoTagline}>
              Know your customer<br />Grow your future.
            </span>
          </div>
        </div>

        {/* Step 1 — email form */}
        <form onSubmit={codeSent ? handleVerifyCode : handleSendCode} className={styles.form}>

          <p className={styles.pageHeading}>Reset your password</p>

          {error && <p className={styles.errorMessage}>{error}</p>}

          {codeSent && (
            <p className={styles.successMessage}>
              Please check your email for your password reset code.
            </p>
          )}

          {/* Email field — always visible */}
          <div className={styles.fieldGroup}>
            <label htmlFor="email" className={styles.label}>Email Address</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className={styles.input}
              autoComplete="email"
              required
              disabled={codeSent}
            />
          </div>

          {/* Reset Code field — visible only after code is sent */}
          {codeSent && (
            <div className={styles.fieldGroup}>
              <label htmlFor="code" className={styles.label}>Reset Code</label>
              <input
                id="code"
                type="text"
                placeholder="Enter the code from your email"
                value={code}
                onChange={e => setCode(e.target.value)}
                className={styles.input}
                autoComplete="one-time-code"
                required
              />
            </div>
          )}

          <div className={styles.buttonRow}>
            {!codeSent ? (
              <Button type="submit" variant="primary" fullWidth disabled={sending}>
                {sending ? 'Sending…' : 'Send Reset Code'}
              </Button>
            ) : (
              <Button type="submit" variant="primary" fullWidth disabled={verifying}>
                {verifying ? 'Verifying…' : 'Verify Code'}
              </Button>
            )}
          </div>

          <div className={styles.links}>
            <button
              type="button"
              className={styles.linkButton}
              onClick={() => navigate('/login')}
            >
              Back to login
            </button>
          </div>

        </form>
      </div>
    </div>
  )
}
